import React, { useState, useEffect } from "react";
import "../assets/css/style.css";

export function InnLoader(props) {
  const classNm = "overlay " + props.className;
  
  return (
    <div className={classNm}>
      <div className="overlay-background"></div>
      <div className="overlay-content">
        <span className="spinner"></span>
        &nbsp;&nbsp;&nbsp; Loading
      </div>
      <div>
        <div className="loader-overlay">
          <div className="loader"></div>
        </div>
      </div>
    </div>
  );
}
